<h1 class="obg-m-responsible-gaming-title" test-id="account-responsible-gaming">
	{{ 'responsible-gaming.title' | translate }}
</h1>

<mat-tab-group [dynamicHeight]="true" [selectedIndex]="selectedIndex" [@.disabled]="true" #tabs>
	<mat-tab>
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.responsible-gaming.information"
				data-test-id="menu.secondary.responsible-gaming.information"
			>
				{{ 'responsible-gaming.information.header' | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<div [innerHtml]="'responsible-gaming.information.text' | translate"></div>
		</ng-template>
	</mat-tab>

	<mat-tab *ngIf="isDepositLimitEnabled">
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.responsible-gaming.deposit-limits"
				data-test-id="menu.secondary.responsible-gaming.deposit-limits"
			>
				{{ 'deposit-limit.title' | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<obg-lazy-loader [lazyItem]="depositLimitModule"></obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<mat-tab
		[label]="'responsible-gaming.deposit-limit-calculator.header' | translate"
		*ngIf="isDepositLimitCalculatorEnabled$ | async"
	>
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.responsible-gaming.deposit-limit-calculator"
				data-test-id="menu.secondary.responsible-gaming.deposit-limit-calculator"
			>
				{{ 'responsible-gaming.deposit-limit-calculator.header' | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<obg-lazy-loader [lazyItem]="depositLimitCalculatorModule"></obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<mat-tab [label]="'responsible-gaming.session-limit.title' | translate" *ngIf="isMultiSessionLimitEnabled">
		<ng-template matTabContent>
			<ng-container [ngSwitch]="jurisdiction">
				<obg-m-sga-session-limit-container
					*ngSwitchCase="'Sga'"
					autoFocusDisabled
				></obg-m-sga-session-limit-container>
				<obg-m-hgc-session-limit-container
					*ngSwitchCase="'Hgc'"
					autoFocusDisabled
				></obg-m-hgc-session-limit-container>
				<obg-m-ksa-session-limit-container
					*ngSwitchCase="'Ksa'"
					autoFocusDisabled
				></obg-m-ksa-session-limit-container>
				<obg-m-zhh-session-limit-container
					*ngSwitchCase="'Zhh'"
					autoFocusDisabled
				></obg-m-zhh-session-limit-container>
				<obg-m-multi-session-limit-container
					*ngSwitchCase="'COGA'"
					autoFocusDisabled
				></obg-m-multi-session-limit-container>
				<obg-m-multi-session-limit-container
					*ngSwitchCase="'BRA'"
					autoFocusDisabled
				></obg-m-multi-session-limit-container>
			</ng-container>
			<obg-m-argentine-session-limit-container
				*ngIf="isArgentineJurisdiction"
				[jurisdiction]="jurisdiction"
				autoFocusDisabled
			></obg-m-argentine-session-limit-container>
		</ng-template>
	</mat-tab>

	<mat-tab [label]="'balance-limit.title' | jurisdiction | translate" *ngIf="isBalanceLimitEnabled">
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.support.responsible-gaming-information.balance-limit"
				data-test-id="menu.secondary.support.responsible-gaming-information.balance-limit"
			>
				{{ 'responsible-gaming.balance-limit.title' | jurisdiction | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<obg-lazy-loader [lazyItem]="balanceLimitModule"></obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<mat-tab
		[label]="'betting-limit.title' | jurisdiction | translate"
		*ngIf="(isBettingLimitEnabled || isBettingLimitV2Enabled) && (isAuthenticated$ | async)"
	>
		<ng-template matTabContent>
			<responsible-gaming_betting_limit
				#rgBettingLimitElement
				[config]="bettingLimitComponentConfig"
				[activeLimit]="bettingLimitActive$ | async"
				[content]="bettingLimitContent$ | async"
				[periodContent]="bettingLimitPeriods$ | async"
				[limitTypesContent]="bettingLimitTypesContent$ | async"
				[queuedLimit]="bettingQueuedLimit$ | async"
				[bettingLimitForm]="bettingLimitForm"
				(removeLimitRequest)="removeBettingLimitRequest()"
				(unsavedChanges)="markUnsavedChanges($event)"
				(limitSubmission)="bettingLimitSubmission($event)"
				(bettingLimitType)="onBettingLimitType($event.detail)"
				*ngIf="isBettingLimitWebComponentEnabled ; else angularBettingLimit"
			></responsible-gaming_betting_limit>
		</ng-template>
		<ng-template #angularBettingLimit>
			<obg-lazy-loader [lazyItem]="bettingLimitModule"> </obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<mat-tab
		[label]="'netloss-limit.title' | jurisdiction | translate"
		*ngIf="isNetlossLimitEnabled && (isAuthenticated$ | async)"
	>
		<ng-template matTabContent>
			<customer-rg_netloss_limit
				#rgNetlossLimitElement
				[config]="netlossLimitComponentConfig"
				[content]="netlossLimitContent$ | async"
				[queuedLimit]="netLossLimitQueued$ | async"
				[activeLimit]="netLossLimitActive$ | async"
				[periodContent]="netLossLimitPeriods$ | async"
				(removeLimitRequest)="removeNetlossLimitRequest()"
				(limitSubmission)="netlossLimitSubmission($event)"
				(unsavedChanges)="markUnsavedChanges($event)"
				*ngIf="isNetlossLimitWebComponentEnabled; else angularNetlossLimit"
			>
			</customer-rg_netloss_limit>
			<ng-template #angularNetlossLimit>
				<obg-lazy-loader [lazyItem]="netlossLimitModule"></obg-lazy-loader>
			</ng-template>
		</ng-template>
	</mat-tab>

	<mat-tab [label]="'responsible-gaming.logout-cooldown.title' | translate" *ngIf="isLoginLimitEnabled">
		<ng-template matTabContent>
			<ng-container [ngSwitch]="jurisdiction">
				<obg-m-zhh-logout-cooldown-container
					*ngSwitchCase="'Zhh'"
					autoFocusDisabled
				></obg-m-zhh-logout-cooldown-container>
			</ng-container>
		</ng-template>
	</mat-tab>

	<mat-tab *ngIf="isTimeOffEnabled && (isAuthenticated$ | async)">
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.responsible-gaming.time-out"
				data-test-id="menu.secondary.responsible-gaming.time-out"
			>
				{{ 'time-off.title' | jurisdiction | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<customer-rg_time_off
				[config]="timeOffComponentConfig$ | async"
				[content]="timOffContent$ | async"
				[periods]="timeOffPeriods$ | async"
				[timeoutTranslation]="timeOffTranslations$ | async"
				(coolOffSubmission)="take24HourBreak()"
				(timeOffSubmission)="timeOffSubmit($event)"
				(unsavedChanges)="markUnsavedChanges($event)"
				*ngIf="isTimeOffWebComponentEnabled; else angularTimeOff"
			>
			</customer-rg_time_off>
			<ng-template #angularTimeOff>
				<obg-lazy-loader [lazyItem]="timeOffModule"></obg-lazy-loader>
			</ng-template>
		</ng-template>
	</mat-tab>

	<mat-tab
		test-id="login-limit-tab"
		data-test-id="login-limit-tab"
		[label]="'login-limit.title' | jurisdiction | translate"
		*ngIf="isLoginLimitEnabled"
	>
		<ng-template matTabContent>
			<obg-lazy-loader [lazyItem]="loginLimitModule"></obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<mat-tab [label]="'self-exclusion.title' | jurisdiction | translate" *ngIf="isSelfExclusionEnabled">
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.responsible-gaming.self-exclusion"
				data-test-id="menu.secondary.responsible-gaming.self-exclusion"
			>
				{{ 'self-exclusion.title' | jurisdiction | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<obg-lazy-loader [lazyItem]="selfExclusionModule"></obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<mat-tab [label]="'self-exclusion.indefinite.title' | jurisdiction | translate" *ngIf="isIndefiniteSeTabEnabled">
		<ng-template mat-tab-label>
			<div
				test-id="menu.secondary.responsible-gaming.indefinite-self-exclusion"
				data-test-id="menu.secondary.responsible-gaming.indefinite-self-exclusion"
			>
				{{ 'self-exclusion.indefinite.title' | jurisdiction | translate }}
			</div>
		</ng-template>
		<ng-template matTabContent>
			<obg-lazy-loader [lazyItem]="indefiniteSelfExclusionModule"></obg-lazy-loader>
		</ng-template>
	</mat-tab>

	<ng-container *ngIf="isJurisdictionAams">
		<mat-tab
			test-id="underage-gambling-tab"
			data-test-id="underage-gambling-tab"
			[label]="'responsible-gaming.underage-gambling.title' | translate"
		>
			<ng-template matTabContent>
				<div [innerHtml]="'responsible-gaming.underage-gambling.description' | translate"></div>
			</ng-template>
		</mat-tab>

		<mat-tab
			test-id="casino-games-wins-tab"
			data-test-id="casino-games-wins-tab"
			[label]="'responsible-gaming.casino-games-wins.title' | translate"
		>
			<ng-template matTabContent>
				<div [innerHtml]="'responsible-gaming.casino-games-wins.description' | translate"></div>
			</ng-template>
		</mat-tab>
	</ng-container>
</mat-tab-group>
